<template>
	<v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
		<template v-slot:activator="slotProps">
			<slot name="activator" v-bind="slotProps" :displayDate="displayDate">
				<v-text-field
					v-model="displayDate"
					:label="label"
					prepend-icon="mdi-calendar"
					readonly
					v-bind="slotProps.props"
					:rules="rules"
					:hint="hint"
					:persistent-hint="persistentHint"
				></v-text-field>
			</slot>
		</template>
		<v-date-picker
			v-model="internalDate"
			@update:model-value="handleDateChange"
			:max="maxDate"
			color="primary"
		></v-date-picker>
	</v-menu>
</template>

<script>
import { format, parse } from 'date-fns'

// 引入 date-fns

export default {
	name: 'CustomDatePicker',
	props: {
		modelValue: {
			type: String,
			default: null // v-model 绑定的字符串值
		},
		format: {
			type: String,
			default: 'yyyy-MM-dd' // 默认格式 YYYY-MM-DD
		},
		label: {
			type: String,
			default: '选择日期'
		},
		rules: {
			type: Array,
			default: () => []
		},
		hint: {
			type: String,
			default: ''
		},
		persistentHint: {
			type: Boolean,
			default: false
		},
		max: {
			type: String,
			default: null // 最大日期（字符串，如 "2025-12-31"）
		}
	},
	data() {
		return {
			menu: false,
			internalDate: null // 内部使用的 Date 对象
		}
	},
	computed: {
		displayDate: {
			get() {
				// 返回格式化的字符串
				return this.modelValue || ''
			},
			set(value) {
				// 处理直接输入（可选，当前为只读）
				if (value) {
					try {
						const parsed = parse(value, this.format, new Date())
						if (!isNaN(parsed.getTime())) {
							this.internalDate = parsed
							this.updateValue(parsed)
						}
					} catch (e) {
						console.warn('无效的日期输入:', value)
					}
				}
			}
		},
		maxDate() {
			// 转换为 Date Picker 可用的格式
			return this.max || null
		}
	},
	watch: {
		modelValue(newVal) {
			// 当外部更新 modelValue 时，同步 internalDate
			if (newVal) {
				this.internalDate = parse(newVal, this.format, new Date())
			} else {
				this.internalDate = null
			}
		}
	},
	created() {
		// 初始化时解析字符串到 internalDate
		if (this.modelValue) {
			this.internalDate = parse(this.modelValue, this.format, new Date())
		}
	},
	methods: {
		handleDateChange(date) {
			// 日期选择后更新
			this.menu = false
			this.updateValue(date)
		},
		updateValue(date) {
			// 将 Date 对象格式化为字符串并发出事件
			const formatted = date ? format(date, this.format) : null
			this.$emit('update:model-value', formatted)
		}
	}
}
</script>

<style scoped>
/* 可选样式 */
</style>
